import { Plane, Heart, MapPin, Car, Briefcase, Calendar } from "lucide-react";

const CATEGORIES = [
  { icon: Plane, label: "Aéroport", href: "#services" },
  { icon: Heart, label: "Mariages", href: "#services" },
  { icon: MapPin, label: "Tourisme", href: "#services" },
  { icon: Car, label: "Véhicule", href: "#vehicule" },
  { icon: Briefcase, label: "Pro", href: "#services" },
  { icon: Calendar, label: "Réserver", href: "#reservation" },
];

export default function QuickNav() {
  return (
    <section data-testid="quick-nav" className="relative bg-[#181818] border-y border-white/[0.08] py-6">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-center justify-center gap-3 sm:gap-4 flex-wrap">
          {CATEGORIES.map((cat, idx) => {
            const Icon = cat.icon;
            return (
              <a
                key={idx}
                href={cat.href}
                data-testid={`quick-nav-${idx}`}
                className="group flex items-center gap-2.5 px-5 py-2.5 bg-[#222] border border-white/[0.08] hover:border-gold/40 hover:bg-gold/5 transition-all duration-400 rounded-sm"
              >
                <Icon size={15} className="text-gold/60 group-hover:text-gold transition-colors" strokeWidth={1.5} />
                <span className="text-white/70 group-hover:text-white text-xs sm:text-sm tracking-wider font-light transition-colors">
                  {cat.label}
                </span>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
